/**
 * Cross-tab auth sync (BroadcastChannel + storage events).
 */

const CHANNEL_NAME = 'smartgaz-auth';
const AUTH_EVENT_KEY = 'smartgaz_auth_event';
const SESSION_KEY = 'smartgaz_session';

export const AuthSyncEvent = {
  SESSION: 'SESSION',
  LOGOUT: 'LOGOUT',
};

let channel = null;

function getChannel() {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) channel = new BroadcastChannel(CHANNEL_NAME);
  return channel;
}

export function publishAuthEvent(type, payload = {}) {
  const event = { type, ts: Date.now(), ...payload };
  try {
    localStorage.setItem(AUTH_EVENT_KEY, JSON.stringify(event));
  } catch {
    // ignore
  }
  getChannel()?.postMessage(event);
}

export function publishSession({ accessToken, refreshToken, user }) {
  publishAuthEvent(AuthSyncEvent.SESSION, { accessToken, refreshToken, user });
}

export function publishLogout() {
  publishAuthEvent(AuthSyncEvent.LOGOUT);
}

export function subscribeAuthSync(handlers) {
  const onEvent = (event) => {
    if (!event?.type) return;
    if (event.type === AuthSyncEvent.SESSION) handlers.onSession?.(event);
    if (event.type === AuthSyncEvent.LOGOUT) handlers.onLogout?.();
  };

  const bc = getChannel();
  const onMessage = (e) => onEvent(e.data);
  bc?.addEventListener('message', onMessage);

  const onStorage = (e) => {
    if (e.key === SESSION_KEY && e.newValue) {
      try {
        const user = JSON.parse(e.newValue);
        handlers.onSession?.({ user, fromStorage: true });
      } catch {
        // ignore
      }
    }
    if (e.key === AUTH_EVENT_KEY && e.newValue) {
      try {
        onEvent(JSON.parse(e.newValue));
      } catch {
        // ignore
      }
    }
  };
  window.addEventListener('storage', onStorage);

  return () => {
    bc?.removeEventListener('message', onMessage);
    window.removeEventListener('storage', onStorage);
  };
}

export { SESSION_KEY };
